import { f as r } from "./fails.js";
import { c as t } from "./create-property-descriptor.js";
var a = !r(function () {
  var r = Error("a");
  return !("stack" in r) || (Object.defineProperty(r, "stack", t(1, 7)), 7 !== r.stack);
});
export { a as e };